import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FeaturesView from '@/views/FeaturesView.vue'
import DownloadView from '../views/DownloadView.vue'
import PricingView from '../views/PricingView.vue'
import NotesView from '@/views/NotesView.vue'
import LoginView from '@/views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/features',
    name: 'features',
    component: FeaturesView
  },
    {
    path: '/downloads',
    name: 'downloads',
    component: DownloadView
  },
   {
    path: '/pricing',
    name: 'pricing',
    component: PricingView
  }, 
     {
    path: '/notes',
    name: 'notes',
    component: NotesView
  }, 
  {
    path: '/login',
    name: 'login',
    component: LoginView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
